import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        padding: theme.spacing(1),
        [theme.breakpoints.down('xs')]: {
          padding: 0,
        },
      },
      title: {
        fontFamily: '"Exo 2", sans-serif',
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '24px',
        textAlign: 'justify',
        margin: theme.spacing(1.5, 0),
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(0, 2),
        },
      },
      item: {
        margin: theme.spacing(0.5, 0),
        '&:first-of-type': {
          marginTop: theme.spacing(2),
        },
        '&:last-of-type': {
          marginBottom: theme.spacing(2),
        },
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(2, 2, 0),
          '&:first-of-type': {
            marginTop: 0,
          },
        },
      },
      responsiveDivider: {
        marginTop: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
      itemText: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 16,
        fontWeight: 300,
        lineHeight: '24px',
        textAlign: 'justify',
      },
      itemPerc: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '24px',
        textAlign: 'right',
        color: sicrediColor.primarySicredi,
      },
      itemProgress: {
        marginTop: theme.spacing(1),
      },
      advice: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 15,
        fontWeight: 400,
        lineHeight: '24px',
        textAlign: 'justify',
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(1, 2),
        },
      },
    }),
  { name: 'RespostaPautaAGO' }
);
